<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col>
        <b-card class="bg-light shadow">
          <b-card-title title-tag="h6">
            Factures
            <span v-if="resultsInfo">({{ resultsInfo }} résultats)</span>
          </b-card-title>
          <div class="d-flex justify-content-start align-items-center">
            <b-button
              size="sm"
              icon
              variant="success"
              :to="{ name: 'newGenericInvoice' }"
              title="Nouvelle facture générique"
              ><b-icon-plus-circle-fill></b-icon-plus-circle-fill
            ></b-button>
            <b-button
              size="sm"
              icon
              class="ml-3"
              variant="info"
              :to="{ name: 'chartAccounts' }"
              title="Tableau comptable"
              ><b-icon-bar-chart-line-fill></b-icon-bar-chart-line-fill
            ></b-button>
            <b-button
              size="sm"
              class="ml-3"
              icon
              variant="secondary"
              :to="{ name: 'addInvoicesPayments' }"
              title="Réceptionner des paiements"
              ><b-icon-credit-card-fill></b-icon-credit-card-fill
            ></b-button>
            <b-button
              icon
              :to="{ path: '/invoices-commissions' }"
              class="ml-3"
              size="sm"
              title="Factures commissions"
              ><i class="fad fa-file-invoice"></i>
            </b-button>
            <label class="mx-3 align-self-center">Rechercher : </label>
            <mh-input
              @enter="submitSearch()"
              autofocus
              append="🔍"
              field="search"
              :table="searchTable"
              :autocomplete="{
                field:
                  'creancier.nom_soc || creancier.(nom prenom) || facture.ID || facture.type',
              }"
            >
            </mh-input>
            <label class="mx-3 align-self-center">Type : </label>
            <mh-input
              @change="submitSearch()"
              autofocus
              append="🔍"
              field="type"
              :table="searchTable"
            >
            </mh-input>
          </div>
          <b-row v-if="$options.invoices.length > 0" class="mt-3">
            <b-col sm="12" md="12" lg="12" :key="render">
              <list
                @changePage="changePage"
                @removeFilter="removeFilter"
                @changeSort="changeSort"
                :items="$options.invoices"
                :fields="fields"
              >
                <template v-slot:cell(ID)="data">
                  <router-link
                    :to="{ name: 'invoiceView', params: { id: data.item.ID } }"
                    >{{ data.item.ID }}</router-link
                  >
                </template>
                <template v-slot:cell(creancier)="data">
                  <router-link
                    :to="{
                      name: 'creditorEdit',
                      params: { id: data.item.creancierID },
                    }"
                    ><span v-html="company(data.item.creancier)"></span
                    ><span
                      class="ml-3"
                      v-html="fullName(data.item.prenom, data.item.nom)"
                    ></span
                  ></router-link>
                </template>
                <template v-slot:cell(actions)="data">
                  <b-button
                    variant="success"
                    :to="{ name: 'invoiceView', params: { id: data.item.ID } }"
                    title="Éditer"
                    size="sm"
                    class="btn-xs"
                    icon
                  >
                    <b-icon-pencil-square></b-icon-pencil-square>
                  </b-button>
                  <b-button
                    variant="info"
                    :to="{
                      name: 'invoiceView',
                      params: { id: data.item.ID, tab: 'Paiements' },
                    }"
                    title="Paiement"
                    size="sm"
                    class="btn-xs ml-2"
                    icon
                  >
                    <b-icon-credit-card></b-icon-credit-card>
                  </b-button>
                  <b-button
                    v-if="data.item.envoiEmail == 'yes'"
                    variant="info"
                    @click="sendMail(data.item)"
                    title="Envoyer la facture par mail"
                    size="sm"
                    class="btn-xs ml-2"
                    icon
                  >
                    <b-icon-envelope></b-icon-envelope>
                  </b-button>
                  <b-button
                    title="PDF de la facture"
                    icon
                    size="sm"
                    class="btn-xs ml-2"
                    variant="info"
                    target="_blank"
                    :href="getPathUrl(data.item.ID)"
                  >
                    <b-icon-printer-fill></b-icon-printer-fill>
                  </b-button>
                  <b-button
                    v-if="$store.getters.isSuperAdmin"
                    variant="danger"
                    @click="avertInvoice(data.item)"
                    title="Supprimer"
                    size="sm"
                    class="btn-xs ml-2"
                    icon
                  >
                    <b-icon-x-circle-fill></b-icon-x-circle-fill>
                  </b-button>
                </template>
              </list>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      title="Envoyer la facture par mail"
      id="email-invoice"
      size="lg"
      title-class="text-center"
      hide-footer
    >
      <InvoiceMail
        @close="$bvModal.hide('email-invoice')"
        object="facture"
        :invoice_id="invoice_id"
      ></InvoiceMail>
    </b-modal>
    <b-modal
      size="xxl"
      title="Effacement d'une facture"
      id="avert-invoice"
      hide-footer
      title-class="text-center"
    >
      <b-row v-if="info_invoice !== null">
        <b-col lg="4">
          <b-card class="bg-light shadow">
            <h6 class="card-title">Facture</h6>
            <table class="table table-sm">
              <tr>
                <td>
                  Créancier :
                  <router-link
                    :to="{
                      name: 'creditorEdit',
                      params: { id: info_invoice.facture.creancierID },
                    }"
                    >{{ info_invoice.facture.creancier }}</router-link
                  >
                </td>
              </tr>
              <tr>
                <td>Type : {{ info_invoice.facture.type }}</td>
              </tr>
              <tr>
                <td>Date : {{ info_invoice.facture.date }}</td>
              </tr>
              <tr>
                <td>Prix HTVA : {{ info_invoice.facture.prixHTVA }} €</td>
              </tr>
              <tr>
                <td>TVA : {{ info_invoice.facture.tva }} %</td>
              </tr>
            </table>
          </b-card>
        </b-col>
        <b-col lg="8" v-if="info_invoice.error">
          <b-alert variant="danger" show>
            {{ info_invoice.error }}
          </b-alert>
        </b-col>
        <b-col lg="8" v-else-if="info_invoice.warning">
          <b-alert variant="warning" show>
            <span v-html="info_invoice.warning"></span>
          </b-alert>
        </b-col>
        <b-col
          lg="12"
          class="mt-2"
          v-if="info_invoice.facture.type == 'commission'"
        >
          <b-card class="bg-light shadow">
            <h6>Paiements débiteur liés à cette facture</h6>
            <table class="table table-sm table-striped">
              <tr>
                <th>Mandat</th>
                <th>Débiteur</th>
                <th>Encodé le</th>
                <th>Type</th>
                <th>Date</th>
                <th>Montant</th>
                <th>Compte cré.</th>
                <th>Compte déb.</th>
                <th>Extrait</th>
                <th>Réception</th>
                <th>Négocié</th>
              </tr>
              <tbody>
                <tr v-for="(paiement, i) in info_invoice.paiements" :key="i">
                  <td>
                    <b-link
                      :to="{
                        name: 'warrantView',
                        params: { id: paiement.mandatID },
                      }"
                      target="_blank"
                    >
                      {{ paiement.mandatID }}
                    </b-link>
                  </td>
                  <td>
                    <router-link
                      :to="{
                        name: $store.getters.isAdmin
                          ? 'debtorEdit'
                          : 'debtorView',
                        params: { id: paiement.debiteurID },
                      }"
                      >{{ paiement.debiteur }}</router-link
                    >
                  </td>
                  <td>{{ paiement.date_encodage }}</td>
                  <td>{{ paiement.type }}</td>
                  <td>{{ paiement.date }}</td>
                  <td>{{ paiement.montant }} €</td>
                  <td>{{ paiement.compte_societe }}</td>
                  <td>{{ paiement.compte_debiteur }}</td>
                  <td>{{ paiement.numero_extrait }}</td>
                  <td>{{ paiement.reception }}</td>
                  <td>{{ paiement.nego }}</td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </b-col>
        <b-col lg="12" class="mt-2" v-if="info_invoice.facture.type == 'vente'">
          <b-card class="bg-light shadow">
            <h6 class="card-title">Carnet de mandats</h6>
            <p class="card-subtitle">
              Date d'achat des mandats :
              {{ info_invoice.carnet.historique.date_creation }}, numéro
              d'historique : {{ info_invoice.carnet.historique.id }}
            </p>
            <table class="table table-sm table-striped">
              <tr>
                <th>Mandat</th>
                <th>Status</th>
                <th>Créancier</th>
                <th>Date de création</th>
                <th>Date d'ouverture</th>
              </tr>
              <tbody>
                <tr
                  v-for="(mandat, i) in info_invoice.carnet.historique.mandats"
                  :key="i"
                >
                  <td>
                    <b-link
                      :to="{
                        name: 'warrantView',
                        params: { id: mandat.id },
                      }"
                      target="_blank"
                    >
                      {{ mandat.id }}
                    </b-link>
                  </td>
                  <td>{{ mandat.status }}</td>
                  <td>
                    <router-link
                      :to="{
                        name: 'creditorEdit',
                        params: { id: info_invoice.facture.creancierID },
                      }"
                      >{{ info_invoice.facture.creancier }}</router-link
                    >
                  </td>
                  <td>{{ info_invoice.carnet.historique.date_creation }}</td>
                  <td>{{ mandat.date_ouverture }}</td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </b-col>
        <b-col lg="12" class="mt-2" v-if="info_invoice.produits.length">
          <b-card class="bg-light shadow">
            <h6>Produits liés à la facture</h6>
            <table class="table table-sm table-striped">
              <tr>
                <th>Description</th>
                <th>Unité(s)</th>
                <th>Prix unitaire</th>
                <th>Total</th>
              </tr>
              <tbody>
                <tr v-for="(produit, i) in info_invoice.produits" :key="i">
                  <td>
                    {{ produit.description }}
                  </td>
                  <td>
                    {{ produit.unit }}
                  </td>
                  <td>{{ produit.prix_unitaire }} €</td>
                  <td>{{ produit.prix_unitaire * produit.unit }} €</td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </b-col>
        <b-col lg="12" class="mt-3 d-flex justify-content-end">
          <b-button @click="deleteInvoice({ ID: info_invoice.facture.id})" size="sm" v-if="!info_invoice.error" variant="danger">Confirmer la suppression</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>          
<script>
import List from "@/components/List";
import DateTime from "@/services/DateTime.js";
import String from "@/services/String.js";
import MhInput from "@/components/MhInput.vue";
import invoices from "@/services/invoices.js";
import InvoiceMail from "@/components/InvoiceMail";
export default {
  components: {
    List,
    MhInput,
    InvoiceMail,
  },
  name: "Invoices",
  invoices: [],
  data() {
    return {
      render: 0,
      invoice_id: null,
      info_invoice: null,
      searchTable: {
        search: {
          label: "",
          type: "varchar",
          value: "",
        },
        type: {
          label: "",
          type: "enum",
          value: "all",
          options: [
            {
              value: "all",
              text: "Toutes les factures",
            },
            {
              value: "commission",
              text: "Commission",
            },
            {
              value: "vente",
              text: "Vente",
            },
            {
              value: "note de credit",
              text: "Note de crédit",
            },
            {
              value: "generic",
              text: "Générique",
            },
          ],
        },
      },
      debug: false,
      info: {},
      filters: [],
      page: 1,
      pagination: {},
      loaded: false,
      resultsInfo: false,
      sortBy: "date",
      sortDesc: true,
      busy: false,
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Factures",
          active: true,
        },
      ],
      fields: [
        {
          key: "ID",
          label: "N° de facture",
          sortable: true,
          class: "text-right",
          thStyle: "width:100px",
        },
        {
          key: "creancier",
          label: "Créancier",
          sortable: true,
          class: "text-truncate",
          thStyle: { width: "20%" },
        },
        {
          key: "date",
          label: "Date",
          sortable: true,
          formatter: (value) => {
            return this.toDate(value);
          },
        },
        {
          key: "type",
          label: "Type",
          sortable: true,
          class: "text-center",
        },
        {
          key: "mandat_prix_unitaire",
          label: "Prix unitaire",
          sortable: true,
          class: "text-right",
          formatter: (value) => {
            return value ? value + " €" : "";
          },
        },
        {
          key: "prixHTVA",
          label: "Prix HTVA",
          sortable: true,
          class: "text-right  font-weight-bold",
          formatter: (value) => Number(value).toFixed(2) + " €",
        },
        {
          key: "tva",
          label: "TVA",
          sortable: true,
          class: "text-right",
          formatter: (value, key, item) => {
            return (
              (item.prixHTVA * value).toFixed(2) +
              " € (" +
              item.tva * 100 +
              " %)"
            );
          },
        },
        {
          key: "tvac",
          label: "TVAC",
          sortable: true,
          class: "text-right font-weight-bold",
          formatter: (value, key, item) => {
            return (
              (Number(item.prixHTVA) * (1 + Number(item.tva))).toFixed(2) + " €"
            );
          },
        },
        {
          key: "cloture",
          label: "Clôturé",
          sortable: true,
          class: "text-center",
          formatter: (value) => {
            return value == 'no' ? 'Non' : 'Oui'
          }
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          thStyle: "width:200px",
          class: "text-center",
        },
      ],
    };
  },
  created() {
    this.search = this.$route.params.search || "";
    this.scroll();
    this.loaded = false;
    this.submitSearch();
  },
  methods: {
    getPathUrl(id) {
      return (
        this.$store.getters.url +
        "/invoice/" +
        id +
        "/pdf?token=" +
        encodeURIComponent(localStorage.getItem("vue-token"))
      );
    },
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight + 300 >
          document.documentElement.offsetHeight;
        if (
          bottomOfWindow &&
          this.pagination.numberOfPages > this.page &&
          !this.busy
        ) {
          this.page++;
          this.continueSearch();
        }
      };
    },
    fullName(a, b) {
      return String.fullName(a, b);
    },
    ucfirst(a) {
      return String.ucfirst(a);
    },
    company(a) {
      return String.company(a);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    reinit() {
      this.page = 1;
      this.filters = [];
      return true;
    },
    changeSort(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.submitSearch();
    },
    changePage(page) {
      this.page = page;
      this.submitSearch();
    },
    removeFilter(index) {
      this.filters.splice(index, 1);
      this.submitSearch();
    },
    narrow(object) {
      this.filters.push(object);
      this.submitSearch();
    },
    sendMail(payload) {
      this.invoice_id = payload.ID;
      this.$bvModal.show("email-invoice");
    },
    avertInvoice(payload) {
      this.busy = true;
      invoices.avert_invoice({ invoice_id: payload.ID }).then((response) => {
        if (response.data.success) {
          this.info_invoice = response.data.data;
          this.$bvModal.show("avert-invoice");
          this.busy = false;
        }
      });
    },
    deleteInvoice(payload) {
      this.busy = true;
      this.$bvModal.hide("avert-invoice");
      invoices.delete_invoice({ invoice_id: payload.ID }).then(() => {
        this.$bvToast.toast("Facture supprimée", {
          title: `Recuperator`,
          toaster: "b-toaster-top-right",
          variant: "success",
          autoHideDelay: 2000,
          solid: false,
        });
        this.$options.invoices = this.$options.invoices.filter(
          (x) => x.ID !== payload.ID
        );
        this.render++;
        this.busy = false;
      });
    },
    continueSearch() {
      this.busy = true;
      invoices
        .search(
          this.searchTable.search.value,
          this.searchTable.type.value,
          this.filters,
          "",
          this.page,
          this.sortBy,
          this.sortDesc,
          this.activeCreditor
        )
        .then((response) => {
          this.$options.invoices = this.$options.invoices.concat(
            response.data.results.records
          );
          this.pagination = response.data.results.pagination;
          this.busy = false;
        })
        .catch(() => {
          this.loaded = true;
          this.busy = false;
        });
    },
    submitSearch() {
      this.busy = true;
      this.page = 1;

      invoices
        .search_invoices(
          this.searchTable.search.value,
          this.searchTable.type.value,
          this.filters,
          "",
          this.page,
          this.sortBy,
          this.sortDesc
        )
        .then((response) => {
          this.$options.invoices = response.data.results.records;
          this.pagination = response.data.results.pagination;
          this.resultsInfo = this.pagination.totalRecords;
          this.loaded = true;
          this.busy = false;
        })
        .catch(() => {
          this.loaded = true;
          this.busy = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>